var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9334",
    "data-name": "Group 9334",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 514,
    viewBox: "0 0 512 514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_513",
    x: 1,
    y: 4,
    width: 510,
    height: 510,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Subtraction_513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_513-2",
    "data-name": "Subtraction 513",
    d: "M246.032,492A246.066,246.066,0,0,1,150.259,19.336a246.064,246.064,0,0,1,191.5,453.338A244.493,244.493,0,0,1,246.032,492ZM228.415,331.331h32.352v64.724H390.2v-161.8H325.5V104.817H163.68v64.714H98.945V396.056h129.47V331.331Zm129.438,32.362H325.5V331.331h32.352v32.362Zm-194.173,0H131.328V331.331H163.68v32.362ZM357.853,298.98H325.5V266.607h32.352V298.98Zm-64.714,0H260.766V266.607h32.373V298.98Zm-64.724,0H196.031V266.607h32.384V298.98Zm-64.735,0H131.328V266.607H163.68V298.98Zm129.46-64.724H260.766V201.882h32.373v32.373Zm-64.724,0H196.031V201.882h32.384v32.373Zm-64.735,0H131.328V201.882H163.68v32.373Zm129.46-64.724H260.766V137.168h32.373v32.362Zm-64.724,0H196.031V137.168h32.384v32.362Z",
    transform: "translate(10 10)",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5145",
    "data-name": "Rectangle 5145",
    width: 512,
    height: 512,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntities);
export default __webpack_public_path__ + "static/media/entities.126481535590efe5633c5c0419c2d226.svg";
export { ForwardRef as ReactComponent };